export var getProgressBarValues = function getProgressBarValues(_ref) {
  var totalEntriesAcquired = _ref.totalEntriesAcquired,
    totalEntriesAvailable = _ref.totalEntriesAvailable;
  var entriesAmount = totalEntriesAvailable ? "".concat(totalEntriesAcquired, "/").concat(totalEntriesAvailable !== null && totalEntriesAvailable !== void 0 ? totalEntriesAvailable : 0) : totalEntriesAcquired;
  var showFillingBar = totalEntriesAcquired > 0 || totalEntriesAvailable;
  var fillPercentage = totalEntriesAvailable ? (totalEntriesAcquired !== null && totalEntriesAcquired !== void 0 ? totalEntriesAcquired : 0) * 100 / (totalEntriesAvailable !== null && totalEntriesAvailable !== void 0 ? totalEntriesAvailable : 0) : 100;
  var fillableBar = !!totalEntriesAvailable;
  return {
    entriesAmount: entriesAmount,
    showFillingBar: showFillingBar,
    fillPercentage: fillPercentage,
    fillableBar: fillableBar
  };
};